import { HorizontalTagInput } from '@/components/core'
import { TagOption, TagValidationConfig } from '@/components/core/HorizontalTagInput/HorizontalTagInput.hooks'
import { Advice } from '@/pages/CompanyDetails/key-message/KeyMessage.styles'
import { FocusCheckDot, FocusContainer, FocusItem, FocusItemTitle, FocusTitle, InputGrid } from './FocusSection.styles'

interface Props {
  clientFocusTags: TagOption[]
  competitorFocusTags: TagOption[]
  onClientFocusChange: (tags: TagOption[]) => void
  onCompetitorFocusChange: (tags: TagOption[]) => void
  clientFocusComplete: boolean
  clientFocusRequired?: boolean
  validationConfig?: TagValidationConfig
}

export function FocusSection({
  clientFocusTags,
  competitorFocusTags,
  onClientFocusChange,
  onCompetitorFocusChange,
  clientFocusComplete,
  clientFocusRequired = true,
  validationConfig,
}: Props): JSX.Element {
  return (
    <FocusContainer>
      <FocusTitle>
        Configurações de Foco <Advice>*foco cliente obrigatório</Advice>
      </FocusTitle>

      <InputGrid>
        <FocusItem>
          <FocusItemTitle>
            Foco Cliente
            <FocusCheckDot $filled={clientFocusComplete} $required={clientFocusRequired} />
          </FocusItemTitle>
          <HorizontalTagInput
            placeholder="Digite o foco do cliente separado por ponto e vírgula (;)"
            maxCharacters={200}
            onChange={onClientFocusChange}
            preSelectedTags={clientFocusTags}
            validationConfig={validationConfig}
            showClearButton={true}
          />
        </FocusItem>

        <FocusItem>
          <FocusItemTitle>Foco Concorrente</FocusItemTitle>
          <HorizontalTagInput
            placeholder="Digite o foco do concorrente separado por ponto e vírgula (;)"
            maxCharacters={200}
            onChange={onCompetitorFocusChange}
            preSelectedTags={competitorFocusTags}
            validationConfig={validationConfig}
            showClearButton={true}
          />
        </FocusItem>
      </InputGrid>
    </FocusContainer>
  )
}
